<template>
  <a-radio-group v-model:value="valComputed" name="radioGroup" :options="options">
  </a-radio-group>
</template>

<script setup lang='ts'>
import { computed } from 'vue'

const props = defineProps<{
  value: number
}>()

const emit = defineEmits(['update:value'])

const valComputed = computed({
  get() {
    return props.value
  },
  set(val) {
    emit('update:value', val)
  }
})

const options = [
  { label: '上架', value: 0 },
  { label: '下架', value: 1 },
]

</script>

<style lang='scss' scoped></style>